@use "../../styles/breakpoint" as *;

.wrapper {
    display: flex;
    gap: 40px;

    @media ($below-mobile) {
        display: none;
    }

    @media ($above-mobile) and ($below-tablet) {
        width: 100%;
        justify-content: center;
        margin-top: 30px;
    }
}

.menuButton {
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    padding: 0;
    justify-content: flex-end;
    align-self: flex-end;

    @media ($above-mobile) {
        display: none;
    }

    &[data-state="closed"] {
        flex: 1;
    }

    &[data-state="open"] {
        flex: none;
    }
}

.menuIcon {
    height: 14px;
    width: 21px;
}

.modal {
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    height: 100vh;
    left: 0;
    padding: 36px var(--container-margin);
    position: absolute;
    top: 0;
    width: 100vw;
    z-index: 1000;
}

.closeIcon {
    height: 17px;
    fill: var(--blue);
    width: 17px;
}

.mobileMenu {
    display: flex;
    flex-direction: column;
}
